import * as d3 from "d3";
import { COLOR, SEX, SEX_ENUM, TENSE, TENSE_ENUM, TIMELINE } from "../../../modules/constants";

let defs;
let nodeDropShadow;
let buttonDropShadow;

export const createSvgDefs = (svg) => {

  defs = svg
    .append("defs");

  // create arrow heads
  createArrowHead(defs, "arrow-head-current-officer", TENSE[TENSE_ENUM.CURRENT].COLOR)
  createArrowHead(defs, "arrow-head-notice-officer", TENSE[TENSE_ENUM.NOTICE].COLOR)
  createArrowHead(defs, "arrow-head-past-officer", TENSE[TENSE_ENUM.PAST].COLOR)
  createArrowHead(defs, "arrow-head-future-officer", TENSE[TENSE_ENUM.FUTURE].COLOR)

  createArrowHead(defs, "arrow-head-current-psc", COLOR.GOOD_LIGHT)
  createArrowHead(defs, "arrow-head-past-psc", COLOR.BAD_LIGHT)

  createHorzGradient(defs, "horz-gradient-current", TENSE[TENSE_ENUM.CURRENT].COLOR)
  createHorzGradient(defs, "horz-gradient-notice", TENSE[TENSE_ENUM.NOTICE].COLOR)
  createHorzGradient(defs, "horz-gradient-past", TENSE[TENSE_ENUM.PAST].COLOR)
  createHorzGradient(defs, "horz-gradient-future", TENSE[TENSE_ENUM.FUTURE].COLOR)

  // create link zone head
  const linkZoneEnd = [[0, 0], [0, 1], [.22, 0.5]];

  defs
    .append("marker")
    .attr("class", "link-zone-head")
    .attr("id", "link-zone-head")
    .attr("viewBox", [0, 0, 1, 1])
    .attr("refX", 0)
    .attr("refY", 0.5)
    .attr("markerWidth", 1)
    .attr("markerHeight", 1)
    .attr("orient", "auto-start-reverse")
    .append("path")
    .attr("stroke-width", 0)
    .attr("d", d3.line()(linkZoneEnd))
    .attr("fill", "grey")

  // create shadow filters  
  let filter0 = defs.append("svg:filter")
    .attr("id", "button-drop-shadow");

  buttonDropShadow = filter0.append("svg:feDropShadow")
    .attr("in", "SourceGraphic")
    .attr("flood-color", "black")
    .attr("flood-opacity", 0.3)
    .attr("stdDeviation", 5.0)
    .attr("dx", 2)
    .attr("dy", 2);

  let filter1 = defs.append("svg:filter")
    .attr("id", "node-drop-shadow");

  nodeDropShadow = filter1.append("svg:feDropShadow")
    .attr("in", "SourceGraphic")
    .attr("flood-color", "black")
    .attr("flood-opacity", 0.3)
    .attr("stdDeviation", 5.0)
    .attr("dx", 3)
    .attr("dy", 3);

  let filterBlur = defs.append("filter")
    .attr("id", "blur")
    .attr("height", "150%")
    .append("feGaussianBlur")
    .attr("stdDeviation", 3)
    .attr("result", "blur")

  // Recolor filters for the person node icons, so they match the exact colour used by the
  // Gender filter checkboxes (a flood + composite gives an exact colour, unlike the
  // invert/sepia/hue-rotate CSS filter approximations used elsewhere in this file)
  createRecolorFilter(defs, "recolor-male", SEX[SEX_ENUM.MALE].COLOR)
  createRecolorFilter(defs, "recolor-female", SEX[SEX_ENUM.FEMALE].COLOR)
}

const createRecolorFilter = (defs, name, color) => {
  const filter = defs.append("svg:filter")
    .attr("id", name);

  filter.append("svg:feFlood")
    .attr("flood-color", color);

  filter.append("svg:feComposite")
    .attr("in2", "SourceAlpha")
    .attr("operator", "in");
}

const createArrowHead = (defs, name, color) => {
  const markerBoxSize = 3;
  const arrowPoints = [[0, 0], [0, markerBoxSize], [markerBoxSize, (markerBoxSize / 2)]];
  const arrowHeadY = markerBoxSize / 2;

  defs
    .append("marker")
    .attr("class", name)
    .attr("id", name)
    .attr("viewBox", [0, 0, markerBoxSize, markerBoxSize])
    .attr("refX", markerBoxSize - 1)
    .attr("refY", arrowHeadY)
    .attr("markerWidth", markerBoxSize)
    .attr("markerHeight", markerBoxSize)
    .attr("orient", "auto-start-reverse")
    .append("path")
    .attr("stroke-width", 0)
    .attr("d", d3.line()(arrowPoints))
    .attr("fill", color);
}

const createHorzGradient = (defs, name, color) => {
  let gradient = defs
    .append("linearGradient")
    .attr("class", name)
    .attr("id", name)
    .attr("x1", "0%")
    .attr("x2", "100%")
    .attr("y1", "0%")
    .attr("y2", "0%")

  gradient.append("stop")
    .attr("class", "start")
    .attr("offset", "0%")
    .attr("stop-color", color)
    .attr("stop-opacity", TIMELINE.FUTURE_START_OPACITY)

  gradient.append("stop")
    .attr("class", "end")
    .attr("offset", "100%")
    .attr("stop-color", color)
    .attr("stop-opacity", TIMELINE.FUTURE_END_OPACITY)
}

export const updateFilters = (nexusSize, nodeRadius) => {
  buttonDropShadow
    .attr("stdDeviation", nexusSize / 200)

  nodeDropShadow
    .attr("stdDeviation", nodeRadius / 20)
}

/*
  // vertical gradient
  gradients.vertical = defs
    .append("linearGradient")
    .attr("class", "vertical-gradient")
    .attr("id", "vertical-gradient")
    .attr("x1", "0%")
    .attr("x2", "0%")
    .attr("y1", "0%")
    .attr("y2", "100%");

  gradients.vertical.append("stop")
    .attr("class", "start")
    .attr("offset", "0%")
    .attr("stop-color", "white")
    .attr("stop-opacity", 0);

  gradients.vertical.append("stop")
    .attr("class", "end")
    .attr("offset", "100%")
    .attr("stop-color", "white")
    .attr("stop-opacity", 1);
*/

